export default {
    CREATE: () => `/outlookUser`,
    LIST: () => `/outlookUser`,
    GET_BY_ID: (id) => `/outlookUser/${id}`,
    UPDATE: (id) => `/outlookUser/${id}`,
    DELETE: (id) => `/outlookUser/${id}`,
    GET_ALL_INBOX_OUTLOOK: (query) => `/email/getAllInboxOutlook?${query}`,
    SEARCH_OUTLOOK: (query) => `/email/searchOutlook?${query}`,
};
